import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const BaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');

const listingRoutes: RouteRecordRaw[] = [
    {
        path: '/trip-extras',
        component: BaseDashboard,
        meta: {
            title: 'Trip Extras',
            icon: 'mdi-car-convertible',
            noCache: false,
            isBase: true,
            permissions: ['listings_view'],
            middleware: ['auth'],
            layout: 'Dashboard',
        } as CommonRouteMeta,
        children: [
            {
                path: '',
                components: {
                    default: () => import('@/views/dashboard/listings/tripExtras/BaseTripExtras.vue'),
                    navRightActions: () => import('@/components/dashboard/navActions/AddNewTripExtra.vue'),
                },
                name: 'tripExtras.index',
                meta: {
                    title: 'Trip Extras',
                    icon: 'mdi-car-convertible',
                    noCache: false,
                    isBase: true,
                    helpArticle: 'https://help.fleetwire.io/en/article/add-and-customize-trip-extras-in-fleetwire-440v22/?bust=1747328838295'
                },
            },
            {
                path: 'new',
                components: {
                    default: () => import('@/views/dashboard/listings/tripExtras/NewTripExtra.vue'),
                    navRightActions: () => import('@/components/dashboard/navActions/AddExtraSaveBtn.vue'),
                },
                name: 'extra.new',
                meta: {title: 'New Extra', icon: 'mdi-car-convertible', noCache: false},
            },
        ],
    }
];

export default listingRoutes;
